import { Field, useFormikContext } from 'formik';

import { InputUI, FormErrorUI, FormLabelUI, CheckboxUI, AutoCompleteSelectUI } from '../Interface';

const ServiceOperationFields = ({ viewField, autoCompleteOptions, selectedValues }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();

  return (
    <>
      <div className="grid grid-cols-4 gap-x-4 mx-4">
        <div className="col-span-4 md:col-span-1">
          <Field
            type="text"
            name="code"
            as={InputUI}
            fullWidth
            label={<FormLabelUI text="Kód" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.code} />}
            disabled={viewField}
            InputLabelProps={{ shrink: values.code && values.code !== '' }}
          />
        </div>
        <div className="col-span-4 md:col-span-3">
          <Field
            type="text"
            name="name"
            as={InputUI}
            fullWidth
            label={<FormLabelUI text="Megnevezés" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.name} />}
            disabled={viewField}
            InputLabelProps={{ shrink: values.name && values.name !== '' }}
          />
        </div>
        <div className="md:col-span-1 col-span-4">
          <Field
            type="number"
            name="standardTime"
            as={InputUI}
            fullWidth
            label={<FormLabelUI text="Normaidő" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.standardTime} />}
            disabled={viewField}
            InputLabelProps={{ shrink: values.standardTime && values.standardTime !== '' }}
          />
        </div>
        <div className="col-span-4 md:col-span-1">
          <Field
            type="autocomplete"
            name="quantityUnitId"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Mennyiségi egység" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.quantityUnitId} />}
            onChange={(_e, newVal) => {
              setFieldValue('quantityUnitId', newVal?.value ?? null).then(() => {
                validateField('quantityUnitId');
              });
            }}
            InputLabelProps={{ shrink: values.quantityUnitId !== '' }}
            selectedValue={values.quantityUnitId}
            selectedLabelValue={selectedValues?.quantityUnit?.code}
            dataset={autoCompleteOptions?.quantityUnit}
            disabled
          />
        </div>
      </div>
      <div className="grid grid-cols-4 gap-x-4 mx-4 mb-5">
        <div className="md:col-span-1 col-span-4">
          <Field
            name="attachRequired"
            type="checkbox"
            as={CheckboxUI}
            fullWidth
            label={<FormLabelUI text="Csatolt fájl kötelező" />}
            disabled={viewField}
          />
        </div>
        <div className="md:col-span-1 col-span-4">
          <Field
            name="descriptionRequired"
            type="checkbox"
            as={CheckboxUI}
            fullWidth
            label={<FormLabelUI text="Leírás kötelező" />}
            disabled={viewField}
          />
        </div>
        <div className="md:col-span-1 col-span-4">
          <Field
            name="active"
            type="checkbox"
            as={CheckboxUI}
            fullWidth
            label={<FormLabelUI text="Aktív" />}
            disabled={viewField}
          />
        </div>
      </div>
    </>
  );
};

export default ServiceOperationFields;
